"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueueTypeEnum = exports.QueueClientEnum = void 0;
var QueueClientEnum;
(function (QueueClientEnum) {
    QueueClientEnum["PRODUCER"] = "producer";
    QueueClientEnum["CONSUMER"] = "consumer";
})(QueueClientEnum = exports.QueueClientEnum || (exports.QueueClientEnum = {}));
;
var QueueTypeEnum;
(function (QueueTypeEnum) {
    QueueTypeEnum["PG"] = "pg";
    QueueTypeEnum["AZURE"] = "azure";
})(QueueTypeEnum = exports.QueueTypeEnum || (exports.QueueTypeEnum = {}));
